module.exports = __webpack_public_path__ + "img/gntech_gallery4.171d1d69.jpg";